<template>
  <div class="search-box">
    <Form ref="searchForm" :model="formValidate" :label-width="500">
      <FormItem label="学期">
        <CascaderYearTerms
          ref="cascaderYearTerms"
          style="width:300px"
          :placeholder="`请选择学期`"
          @on-change="onCascaderChange"
        ></CascaderYearTerms>
      </FormItem>
      <FormItem v-if="portOrg==2" prop="schoolId" label="学校">
        {{ userInfo.orgName }}
      </FormItem>
      <FormItem v-else prop="schoolId" label="学校">
        <RemoteSelect
          v-model="formValidate.schoolId"
          style="width:300px"
          placeholder="请选择学校"
          :remote-method="getSchoolList"
          :loading="loadingSchool"
          @change="handleSchoolSelect"
          @clear="getSchoolList('')"
          @visible-change="loadAllList"
        >
          <el-option
            v-for="item in schoolList"
            :key="item.orgId"
            :label="item.schoolName"
            :value="item.orgId"
          >
          </el-option>
        </RemoteSelect>
      </FormItem>

      <FormItem prop="branchId" label="校区">
        <choose-campus
          ref="chooseCampusRef"
          style="width:300px"
          :org-id="formValidate.schoolId"
          @on-change="handleCampusChange"
        ></choose-campus>
      </FormItem>
      <FormItem label="">
        <Button
          type="primary"
          @click="handleSearch"
        >确定，下一步</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ChooseCampus from '@c/searchBlock/ChooseCampus.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import RemoteSelect from '@c/RemoteSelect';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  name: 'SmartDivideSelectSchool',
  components: {
    ChooseCampus,
    RemoteSelect,
    CascaderYearTerms
  },
  data() {
    return {
      formValidate: {
        schoolId: '',
        yearCode: '',
        termCode: '',
        branchId: ''
      },
      schoolList: [],
      loadingSchool: false,
      schoolPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 50
      }
    };
  },
  computed: {
    ...mapState(['portOrg', 'userInfo'])
  },
  mounted() {
    if (+this.portOrg === 2) {
      this.formValidate.schoolId = this.userInfo.orgId;
    }
  },
  methods: {
    // 校区选择branchId
    handleCampusChange(val) {
      this.formValidate.branchId = val;
    },
    async onCascaderChange(v) {
      this.formValidate.yearCode = v.length ? v[0] : '';
      this.formValidate.termCode = v.length ? v[1] : '';
      if (+this.portOrg !== 2) {
        this.formValidate.schoolId = '';
        await this.getSchoolList();
      }
    },
    handleSchoolSelect(option) {
      console.log(option, '学校是===');
      if (!option) {
        return;
      }
      const select = this.schoolList.find(item => {
        return item.schoolId === option;
      });
      this.formValidate.schoolName = select ? select.schoolName : '';
    },
    loadAllList(val) {
      if (!val) {
        this.getSchoolList('');
      }
    },
    // 获取学校列表
    getSchoolList(query) {
      query ? (this.loadingSchool = true) : '';
      const queryTrue = {
        orgName: query,
        yearCode: this.formValidate.yearCode,
        termCode: this.formValidate.termCode,
        orgType: 1
      };
      this.getSchoolListAdmin(queryTrue);
    },
    // 请求学校列表(运营端,教育局端,机构端)
    async getSchoolListAdmin(query) {
      const params = Object.assign(this.schoolPageInfo, query);
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.schoolId = item.orgId;
          item.schoolName = item.name || item.orgName;
          return item;
        });
        this.schoolList.unshift({
          schoolId: -1,
          schoolName: '全部',
          orgId: -1,
          name: '全部学校'
        });
        this.loadingSchool = false;
      }
    },
    handleSearch() {
      let str = '';
      if (this.formValidate.termCode === '') {
        str = '学期';
      }
      if (this.formValidate.schoolId === -1 || this.formValidate.schoolId === '') {
        str = str ? str + '、学校' : '学校';
      }
      if (this.formValidate.branchId === '') {
        str = str ? str + '、校区' : '校区';
      }
      const warningStr = str ? `请先选中${str}后，再进行分班` : '';
      if (warningStr) {
        this.$Message['warning']({
          background: true,
          content: warningStr
        });
        return false;
      }

      this.$emit('search', this.formValidate);
    }
  }
};
</script>
<style lang="scss" scoped>
.search-box{
  padding: 120px 0;
  margin: 0 auto;
  // display: flex;
  // justify-content: center;
}
</style>
